import { defineMessages } from 'dibs-react-intl';

export default defineMessages({
    mostPopularBuyPagesTitle: {
        id: 'popularSearchesSitemap.mostPopularBuyPages',
        defaultMessage: 'Popular Searches in {categoryName}',
    },
    descendantCategoriesTitle: {
        id: 'popularSearchesSitemap.descendantCategories',
        defaultMessage: 'All {categoryName} Searches by Category',
    },
    otherPopularBuyPagesTitle: {
        id: 'popularSearchesSitemap.otherPopularBuyPages',
        defaultMessage: 'Other Popular Searches',
    },
});
